module.exports = __webpack_public_path__ + "img/nodeBackgroundFullWhite.f01d9f5b.svg";